export default __webpack_public_path__ + "resources/icons/n432-6d11.webp";